import { RouteType } from '../types/routes'

export const getGuidFromUrlParams = () => {
  const queryString = window.location.search

  const urlParams = new URLSearchParams(queryString)

  const guid = urlParams.get('guid')
  return guid || ''
}

export const getSalonGuidFromUrlParams = () => {
  const queryString = window.location.search

  const urlParams = new URLSearchParams(queryString)

  const salonGuidFromUrl = urlParams.get('salonGuid')

  if (process.env.REACT_APP_SALON_GUID && !salonGuidFromUrl) return process.env.REACT_APP_SALON_GUID

  return salonGuidFromUrl || ''
}

export const getUrlWithSalonGuid = (path: RouteType) => {
  const salonGuid = getSalonGuidFromUrlParams()
  return salonGuid ? `${path}?salonGuid=${salonGuid}` : path
}
